import { render, staticRenderFns } from "./edit_child_project.vue?vue&type=template&id=92f81970&scoped=true"
import script from "./edit_child_project.vue?vue&type=script&lang=js"
export * from "./edit_child_project.vue?vue&type=script&lang=js"
import style0 from "./edit_child_project.vue?vue&type=style&index=0&id=92f81970&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f81970",
  null
  
)

export default component.exports